/**
 * SECTION - ABOUT
 */
import RouteSelector from "../containers/RouteSelector";
import { views } from "./../services/constants";

const { root } = views;

const AboutRoutes = {
  routes: [
    /*{
      path: ["/about", "/sobre"],
      component: AboutContainer,
      props: {
        activeView: root,
        document: "university"
      }
    },
    {
      path: ["/university", "/universidade"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "university"
      }
    },
    {
      path: ["/history", "/historia"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "history"
      }
    },
    {
      path: ["/structure", "/organizacao"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "structure"
      }
    },
    {
      path: ["/campus", "/campi"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "campus"
      }
    },
    {
      path: ["/how-to-arrive", "/como-chegar"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "howArrive"
      }
    },
    {
      path: ["/community", "/comunidade"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "community"
      }
    },
    {
      path: ["/quality", "/qualidade"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "quality"
      }
    },
    {
      path: ["/facts-figures", "/factos-numeros"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "facts"
      }
    },
    {
      path: ["/know-us", "/conhece-nos"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "knowUs"
      }
    },
    {
      path: ["/about-us", "/sobre-nos"],
      component: RouteSelector,
      props: {
        activeView: root,
        document: "aboutUs"
      }
    }*/
  ]
};

export default AboutRoutes;
